// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { Cross } from '../../assets/svg/common';
import { Target } from '../../client';
import { __ } from '../../i18n/l10n';
import FitRemainingHeight from '../../renderprops/FitRemainingHeight';
import { MatchEntityStatus, type MatchState } from '../../states/entities/matches';
import { SportEntity } from '../../states/entities/sports';
import theme from '../../styled-components/dark';
import { MultiviewBlockWrapper } from '../../styled-components/shared';
import LoadingSpinner from '../LoadingSpinner';
import MatchCardHeaderContainer from '../MatchCardHeader/MatchCardHeaderContainer';
import MatchGroupsContainer from '../MatchGroups/MatchGroupsContainer';
import MatchToolbarContainer from '../MatchToolbar/MatchToolbarContainer';
import ScoreboardContainer from '../Scoreboard/ScoreboardContainer';

const ScoreboardWrapper = styled.div`
  width: ${({ $isSetLayout }) => ($isSetLayout ? 'calc(100% - 3em)' : '100%')};
`;

const Center = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  text-align: center;
`;

const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  overflow: hidden;
`;

const EventHeader = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  background: ${theme.Scoreboards.wrapperBackground};
  margin-bottom: ${({ $isOutright }) => ($isOutright ? '1em' : '0')};
`;

const EventContentWrapper = styled.div`
  position: relative;
`;

const EventContent = styled.div`
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  border-top: ${({ $isOutright }) => ($isOutright ? 'none' : '1px solid #333')};
  box-sizing: border-box;
  && {
    height: ${({ $remainingHeight }) => `${$remainingHeight}px` || 'auto'};
  }
`;

const CloseButton = styled.button`
  position: relative;
  z-index: 1;
  padding: 0;
  background-color: transparent;
  transform: translate3d(-50%, -50%, 0);
  border-radius: 50%;
  width: 1em;
  height: 1em;
  margin-left: 0.7em;
`;

const StyledCardHeaderContainer = styled(MatchCardHeaderContainer)`
  && .badge {
    z-index: 6;
  }
  && .live-badge {
    z-index: 3;
  }
`;

const DeleteIcon = styled(Cross)`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 1em;
  height: 1em;
  transform: translate3d(-50%, -50%, 0);
  background: transparent;
  color: ${({ theme }) => theme.common.colors.light};
  ${Target.__MOBILE__
    ? undefined
    : css`
        &:hover {
          color: ${({ theme }) => theme.common.colors.light};
        }
      `}
`;

const MatchGroupsWrapper = styled.div``;

type MultiviewBlockMatchProps = {
  visible: boolean;
  matchId: number;
  isLoading: boolean;
  isNull: boolean;
  entity?: MatchState;
  status?: string;
  itemPerLine: number;
  userOption: number;
  isLive: boolean;
  delMatch: (...params: unknown) => unknown;
};

const MultiviewBlockMatch = ({
  matchId,
  isLoading,
  isNull,
  entity,
  status,
  visible,
  itemPerLine,
  userOption,
  isLive,
  delMatch,
}: MultiviewBlockMatchProps) => {
  const deleteMatch = () => {
    delMatch(matchId);
  };
  const renderCloseButton = () => (
    <CloseButton onClick={deleteMatch}>
      <DeleteIcon />
    </CloseButton>
  );
  const renderLoading = () => {
    return (
      <MultiviewBlockWrapper>
        {renderCloseButton()}
        <Center>
          <LoadingSpinner />
        </Center>
      </MultiviewBlockWrapper>
    );
  };
  const renderNotFound = () => {
    return (
      <MultiviewBlockWrapper>
        {renderCloseButton()}
        <Center>{__('This event is no longer available')}</Center>
      </MultiviewBlockWrapper>
    );
  };
  const renderMatch = () => {
    const { matchId, isOutright, sportId, matchStart, tvChannels, periodName } = entity ?? {};

    return (
      <MultiviewBlockWrapper>
        {renderCloseButton()}
        <Wrapper>
          <StyledCardHeaderContainer
            matchId={matchId}
            isLive={isLive}
            sportId={sportId}
            startDate={matchStart}
            tvChannel={tvChannels}
            periodName={periodName}
          />
          <EventHeader $isOutright={isOutright}>
            {!isOutright && !MatchEntityStatus.isPrematch(entity?.status) ? (
              <ScoreboardWrapper $isSetLayout={SportEntity.isSetLayout(sportId)}>
                <ScoreboardContainer matchId={entity?.matchId} isMultiview />
              </ScoreboardWrapper>
            ) : null}
          </EventHeader>
          {/* Desktop */}
          <FitRemainingHeight updateKey={itemPerLine | userOption}>
            {({ remainingHeight }) => (
              <EventContentWrapper>
                <EventContent $isOutright={isOutright} $remainingHeight={remainingHeight}>
                  {/* Common */}
                  <MatchToolbarContainer matchId={matchId} isStreamPaused={!visible} />
                  {!MatchEntityStatus.isEnded(entity?.status) ? (
                    <MatchGroupsWrapper>
                      <MatchGroupsContainer matchId={matchId} />
                    </MatchGroupsWrapper>
                  ) : null}
                  {MatchEntityStatus.isEnded(entity?.status) ? (
                    <div>{__('This event is no longer available')}</div>
                  ) : null}
                </EventContent>
              </EventContentWrapper>
            )}
          </FitRemainingHeight>
        </Wrapper>
      </MultiviewBlockWrapper>
    );
  };
  if (isLoading) {
    return renderLoading();
  }

  if (isNull) {
    return renderNotFound();
  }

  if (entity && !MatchEntityStatus.isPrematch(status)) {
    return renderMatch();
  }
  return renderNotFound();
};

export default MultiviewBlockMatch;
